/**
 * v-money 指令：非表格处（汇总卡、详情字段、统计数字）金额负数标红
 *
 * 用法：
 *   <div v-money="row.totalMoney">¥{{ row.totalMoney || 0 }}</div>
 *   <span v-money="{ value: row.balance, field: 'balance' }">{{ row.balance }}</span>
 *
 * 说明：表格单元格由 $moneyCellClass 自动处理，无需再加本指令。
 * 这里直接按「值」判定，无需依赖字段名识别。
 */
import { isNegativeMoney, MONEY_NEGATIVE_CLASS } from "../money.js";

function apply(el, binding) {
	const raw = binding.value;
	let value = raw;
	if (raw && typeof raw === "object" && "value" in raw) {
		value = raw.value;
	}
	if (isNegativeMoney(value)) {
		el.classList.add(MONEY_NEGATIVE_CLASS);
	} else {
		el.classList.remove(MONEY_NEGATIVE_CLASS);
	}
}

export default {
	name: "money",
	bind: apply,
	inserted: apply,
	update: apply,
	componentUpdated: apply
};
